if (!customElements.get('td-cart-progress-bar')) {
  class TDProgressBar extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.progressBar = this.querySelector('.td-progress-bar__bar')
      if (!this.progressBar) {
        return
      }
      this.updateProgress()
    }
    updateProgress() {
      if (this.dataset.oldCartAmount) {
        this.updateSecondaryRender()
      } else {
        this.updatePrimaryRender()
      }
    }
    updateSecondaryRender() {
      const nextTier = this.querySelector('[data-tier-reached="false"]')
      if (nextTier) {
        // Get ALL reached tiers, then take the last one
        const reachedTiers = this.querySelectorAll('[data-tier-reached="true"]')
        const previousTier = reachedTiers[reachedTiers.length - 1]
        
        if (!previousTier) {
          this.updatePrimaryRender();
          return
        }
        
        const previousTierThreshold = parseInt(previousTier.dataset.progressBarItemPrice)
        const nextTierThreshold = parseInt(nextTier.dataset.progressBarItemPrice)
        const currentProgress = parseInt(this.dataset.cartAmount)
        
        // Get the bounding rectangles - use the inner element
        const parentRect = this.getBoundingClientRect()
        const previousTierRect = previousTier.querySelector('.td-progress-bar__progress-inner').getBoundingClientRect()
        const nextTierRect = nextTier.querySelector('.td-progress-bar__progress-inner').getBoundingClientRect()
        
        // Calculate center positions (not left edge)
        const previousTierCenter = previousTierRect.left + (previousTierRect.width / 2) - parentRect.left
        const nextTierCenter = nextTierRect.left + (nextTierRect.width / 2) - parentRect.left
        
        // Calculate the distance between tier centers
        const distanceBetweenTiers = nextTierCenter - previousTierCenter
        
        // Calculate progress within this tier range (0 to 1)
        const progressInRange = (currentProgress - previousTierThreshold) / (nextTierThreshold - previousTierThreshold)
        const progressRatio = Math.min(Math.max(progressInRange, 0), 1)
        
        // Calculate the actual progress width from previous tier center
        const progressWidth = previousTierCenter + (distanceBetweenTiers * progressRatio)
        
        // Convert to percentage of parent width
        const percentage = (progressWidth / parentRect.width) * 100
        
        this.setAttribute('data-progress', percentage)
        this.style.setProperty('--progress', `${percentage}%`)
      } else {
        if (this.querySelector('[data-tier-reached]')) {
          this.setAttribute('data-progress', 100)
          this.style.setProperty('--progress', '100%')
        }
      }
    }
    updatePrimaryRender() {
      const nextTier = this.querySelector('[data-tier-reached="false"]')
      if (nextTier) {
        const nextTierThreshold = parseInt(nextTier.dataset.progressBarItemPrice)
        const currentProgress = parseInt(this.dataset.cartAmount)
        // Get the bounding rectangles
        const parentRect = this.getBoundingClientRect()
        const nextTierRect = nextTier.querySelector('.td-progress-bar__progress-inner').getBoundingClientRect()
        
        // Calculate the distance from parent's left edge to nextTier's left edge
        const distanceToNextTier = nextTierRect.left - parentRect.left
        // Calculate what percentage currentProgress is of nextTierThreshold
        const progressRatio = Math.min(currentProgress / nextTierThreshold, 1)
        // Apply that percentage to the distance
        const progressWidth = distanceToNextTier * progressRatio

        // Convert to percentage of parent width
        const percentage = (progressWidth / parentRect.width) * 100
        
        // Apply the percentage to the CSS custom property
        this.setAttribute('data-progress', percentage)
        this.style.setProperty('--progress', `${percentage}%`)
      } else {
        if (this.querySelector('[data-tier-reached]')) {
          this.setAttribute('data-progress', 100)
          this.style.setProperty('--progress', '100%')
        }
      }
    }
  }
  customElements.define('td-cart-progress-bar', TDProgressBar)
}